export const BASE_URL = 'https://api.livethelife.org';
export const API_URL = `${BASE_URL}/api-admin`;
export const DATE_FORMAT = 'MM-DD-YYYY';
export const DATETIME_FORMAT = 'MM-DD-YYYY HH:mm:ss';
export const GAPI_CLIENT_ID = '279999164316-hqe04qek3cggejrr56b8aakli5bdmtpa.apps.googleusercontent.com';
export const GAPI_API_KEY = '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';
